<template>
  <div class="tab-content sort-type" id="act-list-template">
    <div class="job-list-container">
      <div v-if="list.length === 0">
        <div class=no-data>{{ infoText }}</div>
      </div>
      <div v-else>
        <div class="job-card-grid">
          <div class="job-card" v-for="result in list" :key="result.APP_NO">
            <div class="card-header flex-justify-between">
              <span class="job-tag type2" v-if="annKindType === 'JB'">가치동행일자리</span>
              <span class="job-tag type1" v-else-if="result.bizSe === 'IN49001'">경력인재지원</span>
              <span class="job-tag type2" v-else-if="result.bizSe === 'IN49003'">채용설명회</span>
              <span class="job-tag type3" v-else-if="result.bizSe === 'IN49006'">40대 특화과정</span>
              <span class="job-tag type4" v-else-if="result.bizSe === 'IN49007'">시니어 인력뱅크</span>
              <span class="job-tag type5" v-else-if="result.bizSe === 'IN49008'">구인구직공고</span>
              <span class="job-tag type1" v-else-if="result.bizSe === 'IN49009'">4050 직업훈련</span>
              <span class="job-tag type2" v-else-if="result.bizSe === 'IN49004'">기타</span>
              <span class="status-badge status-darkblue" v-if="result.ACT_ING_STEP_NM === '활동처미배치'">{{result.ACT_ING_STEP_NM}}</span>
              <span class="status-badge status-darkblue" v-else-if="result.ACT_ING_STEP_NM === '활동대기'">{{result.ACT_ING_STEP_NM}}</span>
              <span class="status-badge status-darkblue" v-else-if="result.ACT_ING_STEP_NM === '활동중'">{{result.ACT_ING_STEP_NM}}</span>
              <span class="status-badge status-gray" v-else-if="result.ACT_ING_STEP_NM === '활동종료'">{{result.ACT_ING_STEP_NM}}</span>
              <span class="status-badge status-gray" v-else-if="result.ACT_ING_STEP_NM === '활동포기'">{{result.ACT_ING_STEP_NM}}</span>
              <span class="status-badge status-gray" v-else-if="result.ACT_ING_STEP_NM === '중도포기 완료'">{{result.ACT_ING_STEP_NM}}</span>
              <span class="status-badge status-darkblue" v-else-if="result.ACT_ING_STEP_NM === '중도포기 신청중'">{{result.ACT_ING_STEP_NM}}</span>
            </div>
            <div class="card-body">
              <a href="javascript:void(0);" class="title-line" title="{{ result.ANN_NM }} 상세보기">
                {{ result.ANN_NM }}
              </a>
              <div class="recruitment-info long-type">
                <span>세부사업명 <strong class="bar">{{ result.BIZNM }}</strong></span>
                <span>활동처명 <strong class="bar">{{ result.ACTCOMP_NM }}</strong></span>
                <span>활동처 담당자 <strong class="bar" v-html="result.CHARGR_NM"></strong></span>
                <span>활동기간 <strong class="bar">{{ result.ACT_PART_DE }}</strong></span>
              </div>
              <div class="button-area mypage-type1 mt-0">
                <button type="button" class="btn btn-primary btn-md" @click="goActJnlMonth(result.ANN_NO, result.ACTCOMP_NO, result.APP_NO)">활동일지 작성/조회</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination :totalPages="paginationInfo.totalPageCount" :currentPage.sync="paginationInfo.currentPageNo" :size="paginationInfo.pageSize" @update:currentPage="handlePageChange"></pagination>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import Pagination from '../../shared/Pagination.vue';

export default {
  name: 'act-list-template',
  props: ['annKindType'],
  components: { Pagination },
  data() {
    return {
      list: [],
      paginationInfo: {},
      pagingParam: {
        pageIndex: 1, // 현재 페이지
        pageUnit: 12, // 한 페이지당 목록 수
        pageSize: 10, // 페이징 리스트
      },
    };
  },
  watch: {
    pageIndex: {
      handler() {
        this.getList();
      },
    },
  },
  methods: {
    handleResize() {
      const width = window.innerWidth;
      if (width <= 768) {
        this.pagingParam.pageSize = 5;
      } else {
        this.pagingParam.pageSize = 10;
      }
    },
    getList() {
      this.pagingParam.pageIndex = this.paginationInfo.currentPageNo;
      const url = (this.annKindType === 'JB') ? '/api/act/list' : '/api/in_act/list';
      Axios.get(url, { params: this.pagingParam }).then((response) => {
        const result = response.data.data;
        this.list = result.list.map((item) => {
          const newItem = { ...item };
          // if (!item.JUDGE_ING_CD_NM) newItem.JUDGE_ING_CD_NM = '';
          return newItem;
        });
        this.paginationInfo = result.paginationInfo;
        if (this.list.length === 0) this.infoText = '활동관리 목록이 없습니다.';
      }).catch((e) => {
        console.error(e);
      });
    },
    handlePageChange(newPage) {
      this.paginationInfo.currentPageNo = newPage;
      this.getList();
    },
    goActJnlMonth(ANN_NO, ACTCOMP_NO, APP_NO) {
      const url = (this.annKindType === 'JB')
        ? `/mypage-ActJnlMonthList.do?ANN_NO=${ANN_NO}&ACTCOMP_NO=${ACTCOMP_NO}&APP_NO=${APP_NO}`
        : `/mypage-in_ActJnlMonthList.do?ANN_NO=${ANN_NO}&ACTCOMP_NO=${ACTCOMP_NO}&APP_NO=${APP_NO}`;
      location.href = url;
    },
  },
  created() {
    this.handleResize(); // 초기 로드 시 실행
    window.addEventListener('resize', this.handleResize); // 리사이즈 이벤트 리스너 추가
    this.getList();
  },
  mounted() {

  },
};
</script>



// WEBPACK FOOTER //
// ActList.vue?1b67f436